<h1 mat-dialog-title>QR-Code scannen</h1>
<div mat-dialog-content style="max-width: 300px; text-align:center">
    <p style="text-align:center">(Bitte nutzen Sie einen 2D fähigen Barcode-Scanner)</p>
    <input type="text" #value style="width: 100%; height: 0;" />
</div>
